/*
 * The texts of the mcp extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	sidebar: {
		mcp: 'MCP server',
	},
	pages: {
		mcp_info: {
			title: 'MCP server',
			connection: 'Connection',
			url: 'Server address',
			copy_url: 'Copy address',
			url_copied: 'Address copied',
			connect:
				'An assistant connects with this address and an MCP token, which everyone creates on their {link}; the assistant then sees exactly what that person may see.',
			security_page: 'security page',
			limits: 'At most {requests} calls and {writes} changes per minute and person. Protocol {protocol}.',
			tools: 'Tools ({count})',
			read_only: 'read only',
			writes: 'changes data',
			parameter: 'Parameter',
			type: 'Type',
			description: 'Description',
			required: 'Required',
			no_parameters: 'No parameters.',
			output_schema: 'Output schema',
			no_tools: 'The server offers no tools yet.',
			instructions: 'Instructions to the assistant',
			instructions_hint: 'Every assistant gets them when it connects, before its first tool call.',
			load_failed: 'The details of the MCP server could not be loaded.',
			try_again: 'Try again',
		},
	},
};
